import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=08043fba&scoped=true&"
import script from "./GridView.vue?vue&type=script&lang=js&"
export * from "./GridView.vue?vue&type=script&lang=js&"
import style0 from "./GridView.vue?vue&type=style&index=0&id=08043fba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08043fba",
  null
  
)

export default component.exports